import { ReactNode } from 'react';
import styles from './PageHeader.module.scss';

type PageHeaderProps = {
  title: ReactNode;
  subtitle?: ReactNode;
};

const PageHeader = ({ title, subtitle }: PageHeaderProps) => (
  <header className={styles.header}>
    <h1 className="text-page-title">{title}</h1>
    {!!subtitle && <p className="text-page-subtitle">{subtitle}</p>}
  </header>
);

export { PageHeader };
